<script></script>

<div class="attribution">
  <p>Challenge by <a href="https://www.frontendmentor.io?ref=challenge" target="_blank">Frontend Mentor</a>. Coded by <a href="https://github.com/brasspetals" target="_blank">Anna</a>.</p>
</div>

<style>
  .attribution {
    color: var(--color-grey);
    padding: 1rem;
    margin: 0 auto;
    width: 100%;
    text-align: center;
  }

  .attribution p {
    font-size: 0.8125rem;
    font-weight: 800;
  }

  a { 
    color: var(--color-white);
    transition: color .4s ease;
  }

  a:hover {
    color: var(--color-cyan);
  }
</style>